<!-- *******************************UPLOAD ****************************************************************** -->
<!--waitLoading *ngIf="uploader.isUploading"></waitLoading-->
<form action="#" class="dropzone" id="dropzoneForm">
  <div class="fallback">
    <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)"
      [uploader]="uploader" class="well my-drop-zone">
      <div class="container-fluid m-0">
        <div class="row col-12 m-0 p-0 ">
          <ng-container *ngIf="this.files && this.files.length > 0">
            <span *ngFor="let fileDetails of this.files; let i = index" class="w-100 d-table">
              <documentFile [edit]="true" [documentClass]="documentClass" [fileDetails]="fileDetails"
                (deleteFileItem)="deleteFileItem($event)" (modifyFileItem)="modifyFileItem($event)"
                [readonly]="this.readonly" (addSignature)="addSignature($event)"></documentFile>
            </span>
          </ng-container>
        </div>
      </div>
      <div *ngIf="canAdd()||canEdit()" class="text-center pt-5 pb-5" (click)="uploadInput.click()"
        [ngClass]="(this.canEdit()&&!this.canAdd())?'d-none':'d-block'"><input #uploadInput style="display: none;"
          type="file" ng2FileSelect [uploader]="uploader" [multiple]="allowMultipleFiles"
          accept="{{getAllowExtensions()}}" />
        <button class="alert alert-secondary" [ngClass]="(this.canEdit()&&!this.canAdd())?'d-none':'d-inline-block'"
          disabled="{{(this.canEdit()&&!this.canAdd())?'disabled':''}}" type="button">
          <i class="fas fa-plus description" aria-hidden="true"></i><strong> {{ 'Upload.press' | translate }}
          </strong></button>
      </div>
    </div>
  </div>
</form>